import { tryCatchHelper } from '../../helpers';
import {
  ACTIVO_ACCESOS,
  ALL_ACCESOS,
  LOADING_ALL_ACCESOS,
} from './AccesosReducer';
import { allAccesosService, oneAccesosService } from './AccesosService';

export const allAccesosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_ACCESOS, payload: true });
    const res = await allAccesosService(params);
    dispatch({ type: ALL_ACCESOS, payload: res.data });
    dispatch({ type: LOADING_ALL_ACCESOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_ACCESOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const oneAccesosAction = async (dispatch, id) => {
  try {
    const res = await oneAccesosService(id);
    await setActivoAccesosAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const setActivoAccesosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_ACCESOS, payload: data });
};
